var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"availability_calendar--cell d-flex align-items-center justify-content-center"},[_c('span',{staticClass:"availability_calendar-year",class:!_vm.isOverflown ? 'mb-3' : ''},[_vm._v(_vm._s(_vm.currentYear))])])}
var staticRenderFns = []

export { render, staticRenderFns }